import { gql } from '@apollo/client'

export const Query = gql`
  query Notifications(
    $companyId: ID!,
    $filters: NotificationFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    currentUser {
      id
      notifications(
        companyId: $companyId,
        filters: $filters,
        after: $after,
        before: $before,
        first: $first,
        last: $last
      ) {
        nodes {
          id
          title
          message
          postedAt
        }
        pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
      }
    }
  }
`
